<script setup>
import { __, isNumber, onlyHebrew, getZipCode, setFormValues } from '@/utils';
import { Field, ErrorMessage, useField } from 'vee-validate';
import { inject, ref, watch } from 'vue';
import debounce from 'lodash/debounce';

const {
    companyDisableExistingFields,
    subscriberDisableExistingFields,
    showLoader
} = inject('step2');


const props = defineProps(['type', 'isShipping']);
const showZipCodeError = ref(false);
const disableField = ref(props.type === 'subscriber' ? subscriberDisableExistingFields.value : companyDisableExistingFields.value );
const isShipping = ref(props.type === 'subscriberShipping' || props.type === 'companyShipping' ? true : false)

const { handleChange: handleZipCode} = useField('zipCode');
const { handleChange: handleZipStatus } = useField(`${props.type}ZipStatus`)

const fetchZipCode = debounce(async() => {
    showLoader.value = true;
    const response = await getZipCode(props.type,isShipping.value);
    if ( response ) {
        const apiResponse = JSON.parse(response.data);
        const zipCode = apiResponse.response[0]?.name;

        handleZipStatus(apiResponse.response['error']);

        if (zipCode) {
            showZipCodeError.value = false;
            handleZipCode(zipCode);
            let zipCodeType = 'zipCode';
            setFormValues({
                [zipCodeType]: zipCode
            })
        }else{
            handleZipCode('');
            showZipCodeError.value = true;
        }
    }else{
        handleZipCode('');
    }
    showLoader.value = false;
}, 300);

watch(subscriberDisableExistingFields, () => {
	disableField.value = subscriberDisableExistingFields.value
});

watch(companyDisableExistingFields, () => {
	disableField.value = companyDisableExistingFields.value
}); 
</script>
<template>
    <div class="field field--small  field--mobile-half">
        <ErrorMessage :name="`${type}NumberHome`" as="span" class="field__error" />
        <ErrorMessage name="zipCode" as="span" class="field__error large_padding_top" v-if="type === 'subscriber' || type === 'company'" />
        <ErrorMessage name="shippingzipCode" as="span" class="field__error large_padding_top" v-if="type === 'subscriberShipping' || type === 'companyShipping'" />

        <label for="field-home-number-subscriber">
            {{ __('No. Home') }} *
        </label><!-- /.form__label -->

        <Field 
            type="text"
            :name="`${type}NumberHome`"
            id="field-home-number-subscriber"
            @keypress="isNumber($event)" 
            :disabled="disableField && !isShipping"
            @input="fetchZipCode()"
        />
    </div><!-- /.field -->

    <div class="field field--small  field--mobile-half">
        <ErrorMessage name="zipCode" as="span" class="field__error large_padding_top" v-if="type === 'subscriber' || type === 'company'" />
        <ErrorMessage name="shippingzipCode" as="span" class="field__error large_padding_top" v-if="type === 'subscriberShipping' || type === 'companyShipping'" />
        <ErrorMessage :name="`${type}Entrance`" as="span" class="field__error" />
        <ErrorMessage :name="`${type}ZipStatus`" as="span" class="field__error" v-if="type === 'subscriberShipping' || type === 'companyShipping'" />
        <ErrorMessage :name="`${type}ZipStatus`" as="span" class="field__error" v-if="type !== 'subscriberShipping' && type !== 'companyShipping'" />
        <label for="field-entrance-subscriber">
            {{ __('Entrance') }}
        </label><!-- /.form__label -->

        <Field
            type="text"
            :name="`${type}Entrance`"
            id="field-entrance-subscriber"
            @keydown="onlyHebrew($event)" 
            @input="fetchZipCode()"
        />
    </div><!-- /.field -->

    <div class="field field--small  field--mobile-half">
        <label for="field-apartment-subscriber">
            {{ __('Apartment') }}
        </label><!-- /.form__label -->

        <Field type="text" :name="`${type}Apartment`" id="field-apartment-subscriber"
                @keypress="isNumber($event)" />
    </div><!-- /.field -->

    <div class="field field--small  field--mobile-half">
        <label for="field-floor-subscriber">
            {{ __('Floor') }}
        </label><!-- /.form__label -->

        <Field type="text" :name="`${type}Floor`"  id="field-floor-subscriber"
            @keypress="isNumber($event)" />
    </div><!-- /.field -->

	<Field type="text" name="zipCode" class ="hidden" />
</template>